export enum userTypes {
    LOADING = "LOADING",
    SELECTED_USER = "SELECTED_USER",
    GET_USER_LIST = "GET_USER_LIST",
}
  
export default userTypes;